export { START, START_TOUCH, TOUCH, END } from '../src/NavdexPointType.ts';
export type { NavdexPointType } from '../src/NavdexPointType.ts';
